import { render, staticRenderFns } from "./pies.component.vue?vue&type=template&id=4bda72bc&scoped=true&"
import script from "./pies.component.vue?vue&type=script&lang=js&"
export * from "./pies.component.vue?vue&type=script&lang=js&"
import style0 from "./pies.component.vue?vue&type=style&index=0&id=4bda72bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bda72bc",
  null
  
)

export default component.exports